import { useEffect } from 'react';
import { listenVehicles } from '../../channels/vehiclesChannel';
import { useVehiclesStore } from '../../stores/useVehiclesStore';

export function useVehiclesChannel() {

    useEffect(() => {

        const unsubscribe = listenVehicles(({ tipo, payload }) => {

            const {
                setVehicles,
                upsertVehicle,
                removeVehicle,
                updateVeiculosEmViagem,
                setVeiculosEmViagemSelecionados
            } = useVehiclesStore.getState();

            if (tipo === 'veiculos-sync') {

                setVehicles(payload, false);

            }

            if (tipo === 'veiculo-upsert') {

                upsertVehicle(payload, false);

            }

            if (tipo === 'veiculo-remove') {

                removeVehicle(payload, false);

            }

            if(tipo === 'veiculos-trip') {
                
                updateVeiculosEmViagem(payload, false);
            }

            if (tipo === 'veiculos-trip-selected') {

                setVeiculosEmViagemSelecionados(payload, false);

            }

        });

        return unsubscribe;

    }, []);

}